import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { IFlowCore, IFlowSubscriber } from '../../../modules/epflow'
import { config } from '../../../constants'
import { Locale } from '../../../modules/locale'
import MainModule from '../../../modules/main'

Locale.getInstance().registerKeySet('fr', 'create-event-submitted', {
  eventTitle: 'Événement soumis!',
  exhibitionTitle: 'Exposition soumise!',
  festivalTitle: 'Festival soumis!',
  eventDescription:
    'On a bien reçu votre demande, vous recevrez un accusé de réception à l’adresse liée à votre compte.',
  exhibitionDescription:
    'Votre exposition est maintenant dans les mains de nos équipes pour validation.',
  festivalDescription:
    "On a bien reçu votre demande, vous recevrez un accusé de réception à l'adresse liée à votre compte. Une fois votre festival approuvé, vous serez en mesure de le rechercher et pourrez y ajouter des représentations.",
  buttonText: "Retourner à l'Espace Pro",
})

Locale.getInstance().registerKeySet('en', 'create-event-submitted', {
  eventTitle: 'Event submitted!',
  exhibitionTitle: 'Exhibition submitted!',
  festivalTitle: 'Festival submitted!',
  eventDescription:
    'Your request has gone through. You’ll be receiving confirmation via the email address linked to your account.',
  exhibitionDescription: 'Your exhibition is now in the hands of our teams for validation.',
  festivalDescription:
    'Your request has gone through. You’ll be receiving confirmation via the email address linked to your account. Once your festival is approved, you will be able to find it and add representations to it.',
  buttonText: 'Return to pro space',
})

export interface LvcCreateEventSubmitted {
  flowGroup: string
  flowStep: string
}

export class LvcCreateEventSubmitted extends MinzeElement implements MinzeElement, IFlowSubscriber {
  private core: IFlowCore | undefined
  attrs: Attrs = [
    ['flow-step', ''],
    ['data-type', 'event'],
    ['flow-group', ''],
  ]

  reactive: Reactive = [
    ['existingEventData', '', false],
    ['newEventName', '', false],
    ['eventSearchOrAddData', {}, false],
  ]

  onClickPartnerPage() {
    const lang = MainModule.getInstance().getLang() as 'fr' | 'en'
    window.location.href = config.proSpaceUrl[lang]
  }

  html(): string {
    let mobile = window.innerWidth < 960

    let titleSize = mobile ? 'titleMobileSmall' : 'titleDesktopSmall'
    let messageSize = mobile ? 'medium' : 'large'
    this.iconSize = mobile ? '300px' : '400px'
    return `
        <div class="container">
          <lvc-box class="icon">
             <lvc-charlie-peacesign-icon width="${this.iconSize}" height="${this.iconSize}"></lvc-charlie-peacesign-icon>
          </lvc-box>
          <lvc-box class="title">
            <lvc-text font-preset=${titleSize} class="lvc-modal-title">${Locale.getKey(`create-event-submitted.${this.dataType}Title`)}</lvc-text>
          </lvc-box>
          <lvc-box class="message">
            <lvc-text font-preset=${messageSize} class="lvc-modal-title">${Locale.getKey(`create-event-submitted.${this.dataType}Description`)}</lvc-text>
          </lvc-box>
          <lvc-box class="buttonContainer">
            <lvc-button enable-hover-box-shadow="true" width="${window.matchMedia(' (max-width: 730px)').matches ? '100%' : 'fit-content'}" class="button"
                height="100%" width="100%" font-size="1rem" font-weight="500" padding="14px 24px" name="partnerPageButton" > ${Locale.getKey('create-event-submitted.buttonText')} </lvc-button>
          </lvc-box>
        </div>
  `
  }

  css() {
    return `
    :host {
     
    }
    
    .container {
        text-align: center;
      }
    
      .message {
        margin-top: 10px;
      }
    
      .buttonContainer {
        margin-top: 32px;
        margin-bottom: 20px;
        display: flex;
        justify-content: center; /* Center the child elements horizontally */
        align-items: center;
      }

      .icon{
        display: flex;
        justify-content: center; /* Center the child elements horizontally */
        align-items: center;

      }

  `
  }

  eventListeners: EventListeners = [
    ['[name=partnerPageButton]', 'click', this.onClickPartnerPage.bind(this)],
  ]
}
